/** @jsxImportSource @emotion/react */
import { css, keyframes, SerializedStyles } from "@emotion/react";
import { EngTitle } from "components/atoms/EngTitle/EngTitle";
import { UnderLineButton } from "components/atoms/UnderLineButton/UnderLineButton";

const styles = css`
  width: fit-content;
  opacity: 0;
  font-size: 0.875rem;
  line-height: 2rem;
`;

const fadeIn = keyframes`
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const animation = (fadeInTime = 2.1) => {
  const _fadeInTime = fadeInTime + "s";
  return css`
    /*** transition|animation ***/
    animation-name: ${fadeIn};
    animation-duration: ${_fadeInTime}; /* アニメーションの長さ */
    animation-fill-mode: forwards; /* アニメーション終了時のスタイルをアニメーション終了後でも適用させる */
  `;
};

export type FadeInUnderLineTextSlotProps = {
  text?: {
    style?: SerializedStyles;
  };
};

type Props = {
  cssOverride?: SerializedStyles;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children?: React.ReactNode;
  fadeInTime?: number;
  slotProps?: FadeInUnderLineTextSlotProps;
  animate?: boolean;
};

export const FadeInUnderLineText: React.FC<Props> = ({
  cssOverride,
  onClick,
  children,
  fadeInTime = 2.1,
  slotProps,
  animate = true,
}: Props) => {
  return (
    <span css={[cssOverride, styles, animate && animation(fadeInTime)]}>
      <UnderLineButton onClick={onClick}>
        <EngTitle cssOverride={slotProps?.text?.style}>{children}</EngTitle>
      </UnderLineButton>
    </span>
  );
};
